"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityRfpDetailsEntryDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_rfp_details_entry_entity_1 = require("./opportunity-rfp-details-entry.entity");
const look_up_entity_1 = require("./look-up.entity");
let OpportunityRfpDetailsEntryDocumentMap = class OpportunityRfpDetailsEntryDocumentMap {
};
exports.OpportunityRfpDetailsEntryDocumentMap = OpportunityRfpDetailsEntryDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntryDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "opportunity_rfp_details_entry_id",
        type: "integer",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntryDocumentMap.prototype, "opportunityRfpDetailsEntryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntryDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpDetailsEntryDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_rfp_details_entry_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry !== "undefined" && opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry) === "function" ? _a : Object)
], OpportunityRfpDetailsEntryDocumentMap.prototype, "opportunityRfpDetailsEntry", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "document_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _b : Object)
], OpportunityRfpDetailsEntryDocumentMap.prototype, "documentType", void 0);
exports.OpportunityRfpDetailsEntryDocumentMap = OpportunityRfpDetailsEntryDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_rfp_details_entry_document_map" })
], OpportunityRfpDetailsEntryDocumentMap);
